import React from 'react';

const COLUMNS = [
  {
    title: 'All Insurances',
    body: 'We accept all insurance providers and offer direct billing so claims are submitted on your behalf — you only pay any remaining balance.'
  },
  {
    title: 'Canadian Dental Care Plan',
    body: 'We proudly accept the Canadian Dental Care Plan (CDCP) and will help you understand your coverage and what it means for your treatment.'
  },
  {
    title: 'Flexible Payment Plans',
    body: 'For treatments not fully covered, we offer flexible payment plans so quality dental care stays within reach for every family.'
  }
];

export default function PaymentSection({ onBookClick }) {
  return (
    <section className="relative bg-[#FAF7F2] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="bg-[#EFE9DF] px-8 md:px-16 lg:px-20 py-16 md:py-24">
          <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
            {/* Left: heading */}
            <div className="lg:col-span-5 reveal">
              <div className="text-[10px] tracking-[0.32em] uppercase text-[#8B7355] mb-8">
                Insurance &amp; Payment
              </div>
              <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-[#0B0B0B] leading-[1.05]">
                Clear about <span className="italic text-[#B69463]">coverage</span>, always.
              </h2>
            </div>

            {/* Right: 3 columns */}
            <div className="lg:col-span-7 grid md:grid-cols-3 gap-8 md:gap-6 lg:gap-10">
              {COLUMNS.map((col, i) => (
                <div key={col.title} className="reveal" style={{ transitionDelay: `${i * 90}ms` }}>
                  <div className="h-px w-full bg-[#8B7355]/60 mb-5" />
                  <h3 className="font-display text-2xl text-[#0B0B0B] leading-tight">{col.title}</h3>
                  <p className="mt-5 text-[#0B0B0B]/70 leading-relaxed text-[15px]">{col.body}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
